import {
  Collection,
  TableHeader as AriaTableHeader,
  type TableHeaderProps as AriaTableHeaderProps,
  useTableOptions,
} from "react-aria-components";
import { tv } from "tailwind-variants";

import { Checkbox2 } from "@/components/UI2/atoms/Checkbox";
import { cn } from "@/lib/helpers/cn";
import { Column2 } from "@/ui2/atoms/(table)/Column";

type TableHeader2Props<T extends object> = AriaTableHeaderProps<T> & {
  isSelectionDisabled?: boolean;
};

export function TableHeader2<T extends object>({
  className,
  isSelectionDisabled,
  ...props
}: TableHeader2Props<T>) {
  const { selectionBehavior, selectionMode } = useTableOptions();
  const { tableHeader } = styles();

  return (
    <AriaTableHeader className={cn(tableHeader(), className)} {...props}>
      {selectionBehavior === "toggle" && (
        <Column2>
          {selectionMode === "multiple" && (
            <Checkbox2 isDisabled={isSelectionDisabled} slot="selection" />
          )}
        </Column2>
      )}

      <Collection items={props.columns}>{props.children}</Collection>
    </AriaTableHeader>
  );
}

const styles = tv({
  slots: {
    tableHeader: cn("tw:border-y tw:border-stroke-quaternary", "tw:bg-fill-senary"),
  },
});
